import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-extrabold text-gray-900 mb-8">Terms and conditions – Shuttle Clash (Badminton Event 2025)</h1>
      
      <div className="prose prose-lg text-gray-700 max-w-none">
        <p className="text-lg mb-6">
          Welcome to the official website of Badminton Event 2025 ("we," "us," or "our"). By accessing this website and registering for the event, you agree to comply with the following terms and conditions. Please read them carefully before proceeding. This website is owned by Tieup Solutions Pvt. Ltd (GSTIN: 33AAJCT7522Q1ZR).
        </p>

        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Eligibility</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Participants must be 10 years and above, unless otherwise specified.</li>
              <li>Individuals under 18 must have consent from a parent or legal guardian.</li>
              <li>Organizers reserve the right to deny entry or participation for any reason deemed appropriate, including safety or non-compliance.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Registration and Payment</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Registration must be completed through our official website.</li>
              <li>All personal information provided must be accurate and up-to-date.</li>
              <li>Payment must be made in full at the time of registration. Confirmation will be sent upon successful payment.</li>
              <li>Fees once paid are non-refundable unless the event is cancelled by the organizers.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Ticketing and Entry</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Each participant or spectator must carry a valid registration confirmation for entry.</li>
              <li>Entry may be denied without proper identification or confirmation.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Code of Conduct</h2>
            <p className="mb-3 text-gray-700">Participants and attendees must:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Follow event rules and instructions from event staff or officials</li>
              <li>Show sportsmanship, fairness, and respect to others</li>
              <li>Avoid any behavior that could harm others or disrupt the event</li>
            </ul>
            <p className="mt-3 text-gray-700">
              Organizers reserve the right to remove any individual who violates this code of conduct without a refund.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Event Schedule and Cancellation</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>The event schedule is subject to change due to weather, safety, or logistical concerns.</li>
              <li>In case of cancellation due to unforeseen circumstances (e.g., natural disaster, government restrictions), participants will be notified via the contact details provided during registration.</li>
              <li>The organizers shall not be liable for any personal or travel expenses incurred due to cancellation or rescheduling.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Liability Waiver</h2>
            <p className="mb-3 text-gray-700">Participation in the event is at your own risk.</p>
            <p className="text-gray-700">
              By registering, participants agree that the organizers, sponsors, and venue owners are not responsible for any injury, illness, loss, or damage sustained during the event.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Media Consent</h2>
            <p className="text-gray-700">
              By attending, you grant permission for your photographs, videos, and recordings to be used in promotional materials, press releases, social media, and future event advertising.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Privacy</h2>
            <p className="text-gray-700">
              Any personal information collected will be handled in accordance with our Privacy Policy and will not be shared without consent, except as required by law or for event-related services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Intellectual Property</h2>
            <p className="text-gray-700">
              All content on this website, including logos, graphics, and text, is the property of Badminton Event 2025 and may not be used or reproduced without permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law</h2>
            <p className="text-gray-700">
              These terms shall be governed by and interpreted in accordance with the laws of India. Any disputes shall be resolved in the courts of Namakkal, Tamil Nadu.
            </p>
          </section>
        </div>

        <div className="mt-12 p-6 bg-gray-50 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            <strong>Last updated:</strong> December 2024<br />
            <strong>Event:</strong> Shuttle Clash (Badminton Event 2025)<br />
            <strong>Organizer:</strong> Tieup Solutions Pvt. Ltd (GSTIN: 33AAJCT7522Q1ZR)
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
